export default {
	UNCLAIMED: 2,
	CLAIMED: 1,
	CLAIMED_SOMEONE_ELSE: 0,
};

